export class NCConstants {
  public static readonly HTTP_STATUS_SERVER_ERROR = 500;
  public static readonly HTTP_STATUS_INSUFFICIENT_STORAGE = 507;
  public static readonly HTTP_STATUS_I_AM_A_TEAPOT = 418;
}
